import { HStack } from 'native-base';

import BaseSelect from '../../../BaseSelect';
import { ISelectOptionsGroup, SelectValue } from '../../../types';
import SelectGroupActionButton from '../ActionButton';
import { SelectGroupActionVariants } from '../ActionButton/types';

export type CustomSelectProps = {
  value?: SelectValue;
  options: ISelectOptionsGroup[];
  variant: SelectGroupActionVariants;
  onChange?: (newValue: SelectValue) => void;
  onAction?: VoidFunction;
  showAction?: boolean;
};

export const CustomSelect = ({
  value,
  options,
  variant,
  showAction = true,
  onAction,
  onChange,
}: CustomSelectProps) => {
  return (
    <HStack space="6">
      <BaseSelect
        value={value}
        options={options}
        isLoading={!options.length}
        onChange={onChange}
        isClearable={variant === 'add'}
      />
      {showAction && (
        <SelectGroupActionButton
          isDisabled={!value}
          variant={variant}
          onPress={onAction}
        />
      )}
    </HStack>
  );
};

export default CustomSelect;
